import { render } from "./ModelSlider.vue?vue&type=template&id=d0dabd3e&scoped=true"
import script from "./ModelSlider.vue?vue&type=script&lang=js"
export * from "./ModelSlider.vue?vue&type=script&lang=js"

import "./ModelSlider.vue?vue&type=style&index=0&id=d0dabd3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0dabd3e"]])

export default __exports__